import {
  ErrorResponse,
  ShapeValidation,
  ShapeValidationResponse,
} from './slice/types';

const ERRORS_TO_FIELDS_MAP = {
  '001': ['outerDiameter', 'innerDiameter'],
  '002': ['outsideWidth', 'outsideLength'],
  '003': ['outsideLength', 'insideLength'],
  '004': ['insideLength', 'insideWidth'],
  '005': ['outsideWidth', 'insideWidth'],
  '006': ['innerWidth', 'outsideLength', 'length'],
  '007': ['diameterOfBoltHoles', 'innerDiameter', 'outerDiameter'],
  '008': ['diameterOfBoltHoles', 'outerDiameter'],
  '009': ['innerDiameter', 'diameterOfBoltHoles', 'pitchCircle'],
  '010': ['pitchCircle', 'outerDiameter', 'diameterOfBoltHoles'],
  '011': ['pitchCircle', 'numberOfBoltHoles', 'diameterOfBoltHoles'],
  '012': [
    'outerDiameter',
    'outsideLength',
    'length',
    'outsideWidth',
    'insideWidth',
    'width',
    'diameterOfBoltholes',
    'pitchCircle',
  ],
  '013': ['outerDiameter'],
  '014': ['outerDiameter'],
  '015': ['outsideWidth'],
  '016': ['outsideLength'],
  '022': ['outerDiameter'],
  '023': ['outsideLength'],
  '024': ['outsideWidth'],
  '025': ['outsideLength'],
  '028': ['length'],
  '029': ['width'],
  '030': ['innerDiameter'],
  '031': ['diameterOfBoltHoles'],
  '032': ['length'],
  '033': ['width'],
  '034': ['numberOfBoltHoles'],
  '035': ['innerDiameter', 'outerDiameter'],
  '036': ['insideWidth'],
  '037': ['insideLength'],
};

const extractFieldsWithError: (err: ErrorResponse[]) => string[] = errors => {
  return errors.reduce((acc: string[], cur) => {
    return [...acc, ...(ERRORS_TO_FIELDS_MAP[cur.messageCode] || [])];
  }, []);
};

export const transformValidationDTO: (
  DTO: ShapeValidationResponse,
) => ShapeValidation = dto => {
  const result: ShapeValidation = {
    hasShapeError: dto.hasErrors,
    shapeErrors: dto.errors.map(error => error.messageCode),
    fieldsWithErrors: extractFieldsWithError(dto.errors),
  };
  return result;
};
